/**
 * Canonical kk-profile → shared MA shell chrome.
 *
 * ONE read path for the authenticated user's own profile chrome:
 *   GET /me/profile (Account SoR) → mapProfileToForm → chrome for UserContext.
 *
 * `avatar` here is the DERIVED display URL (presigned `avatarUrl`, or a legacy
 * http Auth0 picture stored on kk-profile). It is rendered from memory only;
 * persistUserInfo strips presigned URLs so they never become stored identity.
 */

import { fetchMyProfile, mapProfileToForm } from "../services/accountService";
import { PROFILE_CHROME_SOURCE_KK_PROFILE } from "./profileIdentity";

export function chromeFromProfileForm(form) {
  const f = form || {};
  return {
    firstName: f.firstName || "",
    lastName: f.lastName || "",
    email: f.email || "",
    avatar: f.avatar || null,
    phoneNumber: f.phoneNumber || "",
    profileSource: PROFILE_CHROME_SOURCE_KK_PROFILE,
  };
}

/** Canonical self read. Throws on API failure (callers decide fallback). */
export async function fetchCanonicalProfileChrome() {
  const payload = await fetchMyProfile();
  return chromeFromProfileForm(mapProfileToForm(payload?.profile));
}
